<app-contract-requests
        *ngIf="contractRequest$ | async as contractRequest; else loading"
        [contractRequest]="contractRequest"
        [dealId]="dealId"
></app-contract-requests>
<ng-template #loading>
    <app-dot-loader-scale class="!my-0 !mx-auto"></app-dot-loader-scale>
</ng-template>
